import React, { Component } from "react";
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as wActs from '../actions/website-actions';
import * as lActs from '../actions/links-actions';
import Select from "react-select";
import * as wConst from "../consts/website-consts";

class HomeHeader extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mobileMenuOpen: false,
      searchTxt: "",
      cities: null,
      cc: null,
    };
    this.showLogin = this.showLogin.bind(this);
  }

  showLogin() {
    this.props.dispatch(wActs.showLogin());
  }

  hasRole(role) {
    let hasRole = false;
    let user = this.props.WebPage.User;
    if(!wActs.isNullOrUndefined(user.Roles) && user.Roles.length) {
      user.Roles.map((v) => {
        if(v === role) {
          hasRole = true;
        }
      });
    }
    return hasRole;
  }

  selectedLocale() {
    return this.props.WebPage.Settings.SelectedLocal;
  }

  getTerm() {
    let url = "";
    if(typeof window !== "undefined") {
      url = window.location.href;
    } else {
      url = "https://www.fakeurl.com" + this.props.WebPage.ServerParams.Query;
    }
    return wActs.getParameterByName("term", url, "");
  }
  getTranslation(key, def="") {
    return wActs.isNullOrUndefined(this.props.WebPage.Translations[key]) ? def : this.props.WebPage.Translations[key];
  }


  doSearch() {
    let term = this.Search.value;
    let cc = wActs.isNullOrUndefined(this.Country.state.value) ? "" : this.Country.state.value;
    let city = wActs.isNullOrUndefined(this.City.state.value) ? "" : this.City.state.value;
    let url = wActs.getCultPath(this.props.WebPage, "/") + "?";
    if(url == "?") {url = "/?";}
    if(!wActs.isNullOrUndefined(cc.rec) && !wActs.isNullOrEmpty(cc.rec.Url)) {
      if(!wActs.isNullOrUndefined(city.rec)) {
        if(!wActs.isNullOrEmpty(city.rec.Url)) {
          let uri = new URL(city.rec.Url);
          url = uri.pathname;
        } else {
          if(!wActs.isNullOrEmpty(term)) { url += url.endsWith("?") ? "term=" + term : "&term=" + term; }
          //if(!wActs.isNullOrEmpty(cc.value)) { url += url.endsWith("?") ? "country=" + cc.value : "&country=" + cc.value; }
          if(!wActs.isNullOrEmpty(city.value)) { url += url.endsWith("?") ? "city=" + city.value : "&city=" + city.value; }
        }
      } else {
        let uri = new URL(cc.rec.Url);
        url = uri.pathname;
      }
    } else if(!wActs.isNullOrUndefined(city.rec) && !wActs.isNullOrEmpty(city.rec.Url)) {
      let uri = new URL(city.rec.Url);
      url = uri.pathname;
    } else {
      if(!wActs.isNullOrEmpty(term)) { url += url.endsWith("?") ? "term=" + term : "&term=" + term; }
      if(!wActs.isNullOrEmpty(city.value)) { url += url.endsWith("?") ? "city=" + city.value : "&city=" + city.value; } else {
        if(!wActs.isNullOrEmpty(cc.value)) { url += url.endsWith("?") ? "country=" + cc.value : "&country=" + cc.value; }
      }
    }
    this.props.history.push(url);
  }


  changeCountry(sel) {
    if(wActs.isNullOrUndefined(sel)) {
      sel = {value: "", label: ""};
    }
    if(wActs.isNullOrUndefined(sel.value)) {
      return;
    }
    let self = this;
    let cc = sel.value;
    fetch(`/api/cities?cc=${cc}&lang=${this.props.WebPage.Settings.SelectedLang}`,{headers: {}, method: "GET"})
      .then(resp => resp.json())
      .then(function(data) {
        if(data.Code == 200) {

          self.setState({cities: data.Result.map((v) => { console.log(v); return {label: v.Name, value: v.Code, rec: {...v, url: v.Url}}; })});
          if(data.Result.length>0) {
            self.City.setState({value: {value: "", label: self.getTranslation("page.allcities", "All Cities")}});
            self.doSearch();
          } else {
            self.City.setState({value: {value: "", label: self.getTranslation("page.allcities", "All Cities")}});
            self.doSearch();
          }
        } else {
        }
      }).catch((ex) => {
    });
  }


  render() {
    let cities = this.state.cities ? this.state.cities : this.props.Cities;
    let cc = null; let cty = null;
    if(!wActs.isNullOrUndefined(this.props.WebPage.Page.Settings) && !wActs.isNullOrUndefined(this.props.WebPage.Page.Settings.Include)) {
      let inc = this.props.WebPage.Page.Settings.Include;
      let prt = inc.split(",");
      prt.map((v) => {
        if(v.length == "2") { //Its A CC
          this.props.Countries.map((c) => {
             if(v == c.value) {
               cc = c;
             }
          });
        }
      });
    }

    if(!wActs.isNullOrUndefined(this.props.WebPage.Page.Template.Country)) {
      let tCC = this.props.WebPage.Page.Template.Country.Code;
      this.props.Countries.map((c) => {
        if(tCC == c.value) {
          cc = c;
        }
      });
    }

    if(!wActs.isNullOrUndefined(this.props.WebPage.Page.Template.City)) {
      let tCty = this.props.WebPage.Page.Template.City.Value;
      cities.map((c) => {
        //console.log(`${c.value} !== ${tCty}`)
        if(c.value.toUpperCase() == tCty.replace(" ","").toUpperCase()) {
          cty = c;
        }
      });
    }

    if(cc !== null) {
      cities = cities.filter((c) => {
        if(!wActs.isNullOrUndefined(c.rec.country)) {
          return c.rec.country.code == cc.value;
        } else {
          return c.rec.Country.Code == cc.value;
        }
      });
    }



    return (
      <div className="hero">
        <div className="container">
          <div className="cell x7">
            <div className="text">
              {typeof window !== "undefined" &&
              <div className="h2text" dangerouslySetInnerHTML={{__html: this.getTranslation("page.escortdude.home.text1")}}></div>
              }
              <p>{this.getTranslation("page.escortdude.home.text2")}</p>
            </div>
            {typeof window !== "undefined" &&
            <form action="">
              <label htmlFor="">{this.getTranslation("page.profile.location")}</label>
              <div className="cell x6 select" style={{fontSize: "15px", marginBottom: "20px", paddingLeft: "0px"}}><Select isClearable placeholder={this.getTranslation("dash.list.select")} ref={(r) => {this.Country = r}} options={this.props.Countries} onChange={(sel) => {this.changeCountry(sel)}} value={cc}/></div>
              <div className="cell x6 select" style={{fontSize: "15px", marginBottom: "20px", paddingRight: "0px"}}><Select isClearable placeholder={this.getTranslation("dash.list.select")} ref={(r) => {this.City = r}} value={cty} options={cities} onChange={(sel) => {setTimeout(() => {this.doSearch()},500)}}/></div>
              <div className="search-wrap">
                <input ref={(r) => {this.Search = r}} type="text" placeholder={this.getTranslation("menu.search")}/>
                <i className="fas fa-search"></i>
                <input type="submit" value={this.getTranslation("menu.search")} onClick={(e) => {
                  e.preventDefault();
                  this.doSearch();
                }}/>
              </div>
            </form>
            }
          </div>
          <div className="cell x5">
            <div className="image-wrap">
              <img src="/imgs/escortdude.png" alt={this.props.WebPage.Settings.SeoName}/>
            </div>
          </div>
          <div className="clear"></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    ServerParams: state.Website.ServerParams,
    Countries: state.Tags.Tags.Countries.map((v) => {return {label: v.Name, value: v.Code, rec: v}}),
    Cities: state.Tags.Tags.Cities.map((v) => {return {label: v.Name, value: v.Code, rec: v}})

  };
}

export default withRouter(connect(mapStateToProps)(HomeHeader));
